import { TableColumn } from '@shared/components/data-table/data-table.component';

// ============================================================================
// TABLE COLUMN CONFIGURATION
// ============================================================================

/**
 * Default column property names (shown on first load)
 * Update these constants to change column property names
 */
export const SERIAL_PROFILE_DEFAULT_COLUMNS = {
  NAME: 'name',
  DESCRIPTION: 'description',
  LOT_REQUIRED: 'lotRequired',
  EXPIRY_REQUIRED: 'expiryRequired',
  SERIAL_REQUIRED: 'serialRequired',
  STATUS: 'status',
} as const;

/**
 * Flexible column property names (can be shown/hidden via column selector)
 * Update these constants to change flexible column property names
 */
export const SERIAL_PROFILE_FLEXIBLE_COLUMNS = {
  CREATION_DATE: 'creationDate',
} as const;

/**
 * Action column property name
 */
export const SERIAL_PROFILE_ACTION_COLUMN = {
  ACTIONS: 'actions',
} as const;

/**
 * Default columns order (shown on first load)
 * Update this array to change the default column order
 */
export const SERIAL_PROFILE_DEFAULT_COLUMNS_ORDER: string[] = [
  SERIAL_PROFILE_DEFAULT_COLUMNS.NAME,
  SERIAL_PROFILE_DEFAULT_COLUMNS.DESCRIPTION,
  SERIAL_PROFILE_DEFAULT_COLUMNS.LOT_REQUIRED,
  SERIAL_PROFILE_DEFAULT_COLUMNS.EXPIRY_REQUIRED,
  SERIAL_PROFILE_DEFAULT_COLUMNS.SERIAL_REQUIRED,
  SERIAL_PROFILE_DEFAULT_COLUMNS.STATUS,
];

/**
 * Flexible columns array (can be shown/hidden via column selector)
 * Update this array to change which columns are flexible
 */
export const SERIAL_PROFILE_FLEXIBLE_COLUMNS_ORDER: string[] = [
  SERIAL_PROFILE_FLEXIBLE_COLUMNS.CREATION_DATE,
];

export const SERIAL_PROFILE_COLUMNS: TableColumn[] = [
  {
    label: 'settings.serial_profile.common.name',
    prop: SERIAL_PROFILE_DEFAULT_COLUMNS.NAME,
    width: 150,
  },
  {
    label: 'settings.serial_profile.common.description',
    prop: SERIAL_PROFILE_DEFAULT_COLUMNS.DESCRIPTION,
    width: 180,
  },
  {
    label: 'settings.serial_profile.table.columns.lot_required',
    prop: SERIAL_PROFILE_DEFAULT_COLUMNS.LOT_REQUIRED,
    width: 90,
    type: 'custom',
  },
  {
    label: 'settings.serial_profile.table.columns.expiry_required',
    prop: SERIAL_PROFILE_DEFAULT_COLUMNS.EXPIRY_REQUIRED,
    width: 90,
    type: 'custom',
  },
  {
    label: 'settings.serial_profile.table.columns.serial_required',
    prop: SERIAL_PROFILE_DEFAULT_COLUMNS.SERIAL_REQUIRED,
    width: 90,
    type: 'custom',
  },
  {
    label: 'settings.serial_profile.common.status',
    prop: SERIAL_PROFILE_DEFAULT_COLUMNS.STATUS,
    width: 120,
    type: 'status',
  },
  {
    label: 'settings.serial_profile.table.columns.creation_date',
    prop: SERIAL_PROFILE_FLEXIBLE_COLUMNS.CREATION_DATE,
    width: 135,
    type: 'custom',
    template: 'dateTemplate',
  },
  {
    label: 'settings.serial_profile.common.actions',
    prop: SERIAL_PROFILE_ACTION_COLUMN.ACTIONS,
    type: 'actions',
    width: 100,
  },
];

